import { $api } from '@service/RequestService';
import { building2Endpoints } from '@utils/constants/apis';
import { useMutation, useQueryClient } from 'react-query';

import { UpdateForm } from '../forms/block/schema';
import { useShaxmatka } from '../hooks';
import { BLOCK } from '../keys';
import { Block, blockSchema } from '../schema';

export const useBlockUpdate = () => {
  const client = useQueryClient();
  const { methods } = useShaxmatka();

  return useMutation<Block, any, UpdateForm>(
    async values => {
      const { data } = await $api.patch(building2Endpoints.INDEX + values.id, values);
      const block = blockSchema.parse(data.data);

      return block;
    },
    {
      onSuccess: async (block, { houseId }) => {
        client.setQueryData<{ blocks: Block[] }>(BLOCK.list({ houseId }).queryKey, data => {
          const blocks = data?.blocks || [];

          if (!blocks.length) return { blocks: [] };

          const idx = blocks.findIndex(b => b.id === block.id);

          blocks[idx] = { ...block };

          methods.closeAction();
          return { blocks };
        });
      }
    }
  );
};
